(function (upp) {
    'use strict';
    upp.service('config', ['$http', '$q', '$rootScope', 'device', 'freeContentAdapterService',
        function ($http, $q, $rootScope, device, freeContentAdapterService) {

            var urlRestService = $UPP.URL_UPPLICATION_REST_SERVICE + 'v2/app/config',
                $PROPS = {
                    id: 'id',
                    ad: 'ad',
                    logo: 'logoPath',
                    template: 'templatePath',
                    childuppName: 'title',
                    webappURL: 'webappURL',
                    uppSignature: 'uppSignature',
                    content: 'content',
                    background: 'backgroundURL',
                    type: 'type',
                    backgroundAllApp : 'backgroundAllApp',
                    notifications: 'notifications',
                    templateFeatures: 'templateFeatures',

                };

            var configPromise,
                storedConfig,
                _forEach = angular.forEach;

            var _setConfig = function (k, v) {
                if (storedConfig) {
                    storedConfig[$PROPS[k]] = v;
                }
            };

            var _getStoredConfig = function () {
                return storedConfig;
            };

            var _getConfigFromServer = function () {
                return $http.post(urlRestService, {
                    device: device.getType()
                });
            };

            var _getConfig = function () {
                if (!configPromise) {
                    configPromise = _getConfigFromServer();
                }
                return configPromise;
            };

            var setModulesConfig = function (modules) {
                var config = storedConfig.modules = {};
                $rootScope.modules = [];

                _forEach(modules, function (module) {
                    var key = module.name;
                    // TODO improve this
                    if (key.toLowerCase() !== 'customeraccount') {
                        if (module.name.toLowerCase() == 'free') {
                            key += '-' + module.id;
                        }
                        config[key] = {
                            available: true,
                            id: module.id,
                            display: module.display
                        };

                        $rootScope.modules.push(_getScopeModule(module));
                    }
                });
            };

            /**
             * Transform a module to a 'module' in the rootScope with url and
             * all the fields needed for the app.
             *
             * @param module
             * @returns {{name: string, available: boolean, id: *, display: *}}
             * @private
             */
            var _getScopeModule = function(module) {
                var result = {
                    // FIXME: change name for type.
                    name: module.name.toUpperCase(),
                    available: true,
                    id: module.id,
                    display: module.display
                };
                if (module.name.toLowerCase() == 'free') {
                    result.url = 'free/' + result.id;
                }
                else {
                    // FIXME: change name for type
                    result.url = module.name == 'home' ? '' : module.name;
                }

                return result;
            };

            var _storeConfig = (function () {
                var setConfigOfProperty = function (propertyKey, config) {
                    storedConfig[propertyKey] = config[propertyKey];
                };

                return function (config) {
                    storedConfig = {};
                    setModulesConfig(config.modules);

                    for (var prop in $PROPS) {
                        if ($PROPS.hasOwnProperty(prop)) {
                            setConfigOfProperty($PROPS[prop], config);
                        }
                    }
                };
            })();

            var _resolveInfoRequestPromise = function (callback) {
                var defer = $q.defer();

                var resolveWithCallback = function () {
                    if (callback) {
                        callback(defer, storedConfig);
                    } else {
                        defer.reject('don"t know how to be resolved');
                    }
                };

                if (!storedConfig) {
                    _getConfig()
                        .then(function (response) {
                            _storeConfig(response.data);
                            resolveWithCallback();
                        },
                        function (error) {
                            defer.reject(error);
                        });
                } else {
                    resolveWithCallback();
                }

                return defer.promise;
            };

            var _resolveInfoRequestOfPropertyPromise = function (property) {
                return _resolveInfoRequestPromise(function (promise, config) {
                    promise.resolve(config[property]);
                });
            };

            /**
             * Function to filter Customer Account module
             *
             * @param module Module to filter
             * @return {boolean} true if customeraccount is found
             * @private
             */
            var _findCustomerAccountModule = function (module) {
                return module.name === 'customeraccount';
            };

            /**
             * Returns ALL active modules configured by the user in the dashboard-
             *
             * @method getActiveModules
             *
             * @return {Promise} When fulfilled, returns an array of active modules
             */
            var getActiveModules = (function () {
                var _promise;

                var initPromise = function () {
                    var defer = $q.defer();

                    _getConfig()
                        .then(function (response) {
                            defer.resolve(response.data.modules);
                        });

                    _promise = defer.promise;
                };

                return function () {
                    if (!_promise) {
                        initPromise();
                    }
                    return _promise;
                };

            })();

            /**
             * Returns only the left menu active modules configured by the user in the dashboard-
             * At this moment: ALL modules EXCEPT customeraccount module
             *
             * @method getActiveModules
             *
             * @return {Promise} When fulfilled, returns an array of active modules EXCEPT customer account module (because is in the right menu)
             */
            var getLeftActiveModules = (function () {
                var _promise;

                var initPromise = function () {
                    var defer = $q.defer();

                    _getConfig()
                        .then(function (response) {
                            var modules = response.data.modules;
                            var leftModules = modules.filter(function(module) {
                                return module.name !== 'customeraccount'
                            });
                            defer.resolve(leftModules);
                        });

                    _promise = defer.promise;
                };

                return function () {
                    if (!_promise) {
                        initPromise();
                    }
                    return _promise;
                };

            })();

            /**
             * Returns only the CUSTOMER ACCOUNT module configured by the user in the dashboard-
             *
             * @method getCustomerAccountModule
             *
             * @return {Promise} When fulfilled, returns the customer Account module, undefined otherwise
             */
            var getCustomerAccountModule = (function () {
                var _promise;

                var initPromise = function () {
                    var defer = $q.defer();

                    _getConfig()
                        .then(function (response) {
                            defer.resolve(response.data.modules.find(_findCustomerAccountModule));
                        });

                    _promise = defer.promise;
                };

                return function () {
                    if (!_promise) {
                        initPromise();
                    }
                    return _promise;
                };

            })();

            /**
             * Returns the name to display of the module configured by the user in the dashboard.
             *
             * @method getModuleDisplayText
             *
             * @param {String} moduleName of the module
             * @return {Promise} When fulfilled, returns the display text of the module
             */
            var getModuleDisplayText = function (moduleName) {
                return _resolveInfoRequestPromise(function (promise, config) {
                    var text,
                        _config = config.modules;

                    if (_config[moduleName]) {
                        text = _config[moduleName].display;
                    }
                    promise.resolve(text);
                });
            };

            /**
             * Check if a module is active (configured as active, visible, available,...) in the dashboard
             *
             * @method isAnActiveModule
             *
             * @param {String} moduleName of the module
             * @return {Promise} If the module is active, the promise will be fulfilled, in the other case, rejected
             */
            var isAnActiveModule = function (moduleName) {
                return _resolveInfoRequestPromise(function (promise, config) {
                    var modulesConfig = config.modules,
                        moduleConfig = modulesConfig[moduleName];

                    if (moduleConfig && moduleConfig.available === true) {
                        promise.resolve(moduleConfig);
                    } else {
                        promise.reject("inactive");
                    }
                });
            };

            /**
             * Returns the properties to build the add of the specific device type
             *
             * @method getAdProps
             *
             * @return {Promise}  If ad info has been retrieved from server, the promise will be fulfilled with it, in the other case, rejected
             */
            var getAdProps = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.ad);
            };

            /**
             * Returns the path of the logo
             * @method getLogoPath
             * @return {Promise}  Returns a promise that will be fullfilled (the path of the logo) or rejected
             */
            var getLogoPath = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.logo);
            };

            /**
             * Returns the path of the background
             * @method getBackground
             * @return {Promise} Returns a promise that will be fullfilled (the path of the background) or rejected
             */
            var getBackground = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.background);
            };

            /**
             * Returns the flag to active the background in all views
             * @method isBackgroundAllApp
             * @return {Promise} Returns a promise that will be fullfilled (the boolean of the background) or rejected
             */
            var isBackgroundAllApp = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.backgroundAllApp);
            };

           /**
            * Returns the web app url of the childupp
            * @method getWebAppURL
            * @return {Promise} Returns a promise that will be fullfilled (web app url) or rejected
            */
            var getWebAppURL = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.webappURL);
            };


            /**
             * Returns the path of the template css.
             * @method getTemplateCssPath
             *
             * @return {Promise}  Returns a promise that will be fullfilled (the path of the template css) or rejected
             */
            var getTemplateCssPath = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.template);
            };

            /**
             * Returns the values configured for template features.
             * @method getTemplateFeaturesConfig
             * @return {Promise<Array<{featureName: string, value: string}>>}
             */
            var getTemplateFeaturesConfig = function() {
                return _resolveInfoRequestOfPropertyPromise($PROPS.templateFeatures) || [];
            }
            /**
             * Returns the id of the childupp
             * @return {Number} ID of the childupp
             */
            var getChilduppId = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.id);
            };

            /**
             * Returns the name of the childupp
             *
             * @method getChilduppName
             *
             * @return {Promise}  Returns a promise that will be fullfilled (the name of the childupp) or rejected
             */
            var getChilduppName = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.childuppName);
            };

            /**
             * Returns the type of the childupp (upplication or wingu)
             *
             * @method getType
             *
             * @return {Promise}  Returns a promise that will be fullfilled (the type of the childupp) or rejected
             */
            var getType = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.type);
            };

            /**
             * Returns the content of the childupp
             *
             * @method getContent
             *
             * @return {Promise}  Returns a promise that will be fullfilled (the content of the childupp, can be null) or rejected
             */
            var getContent = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.content)
                .then(function(content) {
                    if (content)
                        return freeContentAdapterService.parseContent(content);
                    return content;
                });
            };

            /**
             * Returns if the user can login or not
             * User can logic if the Customer Account module is active, false otherwise
             *
             * @method shouldShowAccount
             *
             * @return {Promise}  Returns a promise that will be fullfilled ({true|false}) or rejected
             */
            var shouldShowAccount = (function () {
                var _promise;

                var initPromise = function () {
                    var defer = $q.defer();

                    getActiveModules()
                        .then(function (activeModules) {
                            defer.resolve(activeModules.find(_findCustomerAccountModule) !== undefined);
                        });

                    _promise = defer.promise;
                };

                return function () {
                    if (!_promise) {
                        initPromise();
                    }
                    return _promise;
                };

            })();

            /**
             * Returns if the childupp should show the signature of Upplication
             *
             * @method shouldShowUppSignature
             *
             * @return {Promise<true|false>}  Returns a promise that will be fullfilled ({true|false}) or rejected
             */
            var shouldShowUppSignature = function () {
                return _resolveInfoRequestOfPropertyPromise($PROPS.uppSignature);
            };

            /**
             * Returns if the childupp is no more active (indicated by the server), so the user can not enter the web
             *
             * @method isChilduppInactive
             *
             * @return {Promise}  Returns a promise that will be fullfilled (user can not enter the web)
             */
            var isChilduppInactive = (function () {
                return function () {
                    const CHILDUPP_INACTIVE_CODES = [112, 123, 124];
                    var defer = $q.defer();

                    _getConfig()
                        .then(function () {
                            //if _getConfig promise is resolved, childupp is active (ok)
                            defer.reject({});
                        }, function (error) {
                            if (error.data && CHILDUPP_INACTIVE_CODES.includes(error.data.errorMessageCode)) {
                                defer.resolve({
                                    code: error.data.errorMessageCode,
                                    message: error.data.translatedErrorMessage
                                });
                            } else {
                                defer.reject({warning: 'config of childupp is not ok, but childupp is active'});
                            }
                        });

                    return defer.promise;
                }
            })();

            return {
                getActiveModules: getActiveModules,
                getLeftActiveModules: getLeftActiveModules,
                getCustomerAccountModule: getCustomerAccountModule,
                getModuleDisplayText: getModuleDisplayText,
                isAnActiveModule: isAnActiveModule,
                getAdProps: getAdProps,
                getLogoPath: getLogoPath,
                getTemplateCssPath: getTemplateCssPath,
                getTemplateFeaturesConfig: getTemplateFeaturesConfig,
                isChilduppInactive: isChilduppInactive,
                getChilduppName: getChilduppName,
                getWebAppURL: getWebAppURL,
                getChilduppId: getChilduppId,
                getType: getType,
                shouldShowUppSignature: shouldShowUppSignature,
                getContent: getContent,
                shouldShowAccount: shouldShowAccount,
                getBackground: getBackground,
                isBackgroundAllApp: isBackgroundAllApp,
                _getStoredConfig: _getStoredConfig,
                _setConfig: _setConfig,
                _storeConfig: _storeConfig,
                _setModulesConfig: setModulesConfig
            };
        }]);
})(upp);



// WEBPACK FOOTER //
// ./src/app/common/services/config-service.js